/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Modal from 'components/modal';
import { isModalVisible } from 'state/ui/selectors';
import { createCloseModalAction } from 'state/ui/actions';
import RenameReportForm from 'blocks/rename-report-form';
import { getReportId } from 'state/ui/report-rename-form/selectors';

/**
 * Style dependencies
 */
import './styles.scss';

const RenameReportPopover = ({ reportId, isVisible, closeModal }) => {
	return (
		<Modal title='Rename report' className='rename-report-popover' isVisible={isVisible} close={closeModal}>
			<RenameReportForm onCancel={closeModal} afterSave={closeModal} />
		</Modal>
	);
};

export default connect(
	(state) => ({
		isVisible: isModalVisible('RenameReportPopover')(state),
		reportId: getReportId(state),
	}),
	{
		closeModal: createCloseModalAction('RenameReportPopover'),
	},
)(RenameReportPopover);
